import { LocalizedStringsMethods } from 'react-localization';
import LocalizedStrings  from 'react-localization';

interface IProfileBulkUploadStrings extends LocalizedStringsMethods {
    lsHomeTxt: string;
    lsProfilesTxt: string;
    lsUploadProfileTxt: string;
    lsUploadTxt: string;    
    lsSelectCSVFileTxt: string;
    lsChooseFileTxt: string;
    lsNoFileChoosenTxt: string;
    lsFirstRowHeaderChkBoxTxt: string;
    lsRowHeaderTxt: string;
    lsRowHeaderColTxt: string;
    lsColumnTxt: string;
    lsDescriptionTxt: string;
    lsYesTxt: string;
    lsNoTxt: string;
    lsRequiredTxt: string;
    lsFirstNameTxt: string;
    lsMiddleNameTxt: string;
    lsMiddleNamePlaceholderTxt: string;
    lsLastNameTxt: string;
    lsIDTxt: string;
    lsIDDescTxt: string;
    lsDOBTxt: string;
    lsDOBDescTxt: string;
    lsGenderTxt: string;
    lsSportTxt: string;
    lsLevelTxt: string;
    lsEmailTxt: string;
    lsPhoneTxt: string;
    lsGenderDescTxt: string;
    lsSportDescTxt: string;
    lsLevelDescTxt: string;
    lsEmailDescTxt: string;
    lsPhoneDescTxt: string;
    lsCSVUploadInfoTxt1: string;
    lsCSVUploadInfoTxt2: string;
    lsCSVUploadInfoTxt3: string;
    lsCSVUploadInfoTxt4: string;
    lsCSVUploadInfoTxt5: string;
    lsUploadErrorTxt: string;
    lsPhoneErrorTxt: string;
    lsDOBErrorTxt: string;
    lsEmailErrorTxt: string;
    lsClearTxt: string;
    lsHereTxt: string;
    lsDloadSampleTxt: string;
    lsOtherTxt: string;
}

let strings: IProfileBulkUploadStrings;
export default strings = new LocalizedStrings({
    en: {
        lsHomeTxt: 'Home',
        lsProfilesTxt: 'Profiles',
        lsUploadProfileTxt: 'Upload New Profiles',
        lsUploadTxt: 'Upload',
        lsSelectCSVFileTxt: 'Select the csv file of profiles to upload',
        lsChooseFileTxt: 'Choose file',
        lsNoFileChoosenTxt: 'No file chosen',
        lsFirstRowHeaderChkBoxTxt: 'First row is header',
        lsRowHeaderTxt: 'Each row in the file must contain values for these columns: ',
        lsRowHeaderColTxt: 'Firstname, Lastname, Birth date, Gender',
        lsColumnTxt: 'Column',
        lsDescriptionTxt: 'Description',
        lsYesTxt: 'Yes',
        lsNoTxt: 'No',
        lsRequiredTxt: 'Required',
        lsFirstNameTxt: 'First Name',
        lsMiddleNameTxt: 'Middle Name',
        lsMiddleNamePlaceholderTxt: 'Middle Name or Middle initial',
        lsLastNameTxt: 'Last Name',
        lsIDTxt: 'ID',
        lsIDDescTxt: 'A unique identifier for this profile',
        lsDOBTxt: 'Date of Birth',
        lsDOBDescTxt: `Date of Birth using MM/DD/YYYY format, for example 
a birth date of Nov 1st, 2010 will be entered as 11/01/2010.`,
        lsGenderTxt: 'Gender',
        lsSportTxt: 'Sport',
        lsLevelTxt: 'Level',
        lsEmailTxt: 'Email',
        lsPhoneTxt: 'Phone',
        lsGenderDescTxt: 'Acceptable values are: Male, Female, Other, Unspecified ',
        lsSportDescTxt: `Acceptable values are Football, Soccer, Hockey, Baseball, Basketball, Softball, Tennis,
Volleyball, Mixed Martial Arts, Boxing, Skiing, Snowboarding, Lacrosse, Track and Field, Polo, Rugby, Cycling,
Golf, Walking, Diving, Weightlifting.`,
        lsLevelDescTxt: `Acceptable values are High School, Professional, University, Junior High, Youth,
Recreational/Amateur, Other, Elementary School, Middle School / Junior High, Lower School, Upper School.`,
        lsEmailDescTxt: 'Email ID of the Profile.',
        lsPhoneDescTxt: 'Contact details of the Profile.',
        lsCSVUploadInfoTxt1: 'CSV stands for Comma Separated Values, and it\'s a file format (.csv) for spreadsheets.\
        A CSV file is a text file where each column is separated using a comma (,).',
        lsCSVUploadInfoTxt5: `Note: Email and Phone are required: if you have both values, they will be stored,
otherwise you MUST provide either Email -or- Phone.`,
        lsCSVUploadInfoTxt2: 'Although it can be viewed in Excel to better understand how to construct the CSV\
        file format save it and then use a text editor like Notepad to open the csv file.',
        lsCSVUploadInfoTxt3: 'The sample file when opened in at text editor like Notepad or TextEdit will look like:',
        lsCSVUploadInfoTxt4: 'Then sample file when opened in spreadsheet will look like:',
        lsUploadErrorTxt: 'Issues were found in the below listed rows:',
        lsPhoneErrorTxt: `Please provide below convention for phone number,
country code (area code) subscriber number
E.g, +1-843-298-0595, +1 (843) 298 0595, 1-843-298-0595, (850)9015652, 843-298-0595`,
        lsDOBErrorTxt: `Please provide YYYY/MM/DD or YYYY-MM-DD date format
E.g 2019/02/01, 2019/2/1, 2019-02-01, 2019-2-1`,
        lsEmailErrorTxt: `Please provide valid email address, E.g. john123@mail.com,
"john123" is the email prefix, and "mail.com" is the email domain.`,
        lsClearTxt: 'Clear',
        lsHereTxt: 'here',
        lsDloadSampleTxt: 'Download Sample File',
        lsOtherTxt: 'Other'
    },
    es: {
        lsHomeTxt: 'Home',
        lsProfilesTxt: 'Profiles',
        lsUploadProfileTxt: 'Cargar nuevos perfiles',
        lsUploadTxt: 'Subir',
        lsSelectCSVFileTxt: 'Seleccione el archivo de perfiles csv para cargar',
        lsChooseFileTxt: 'Elija el archivo',
        lsNoFileChoosenTxt: 'NingÃºn archivo elegido',
        lsFirstRowHeaderChkBoxTxt: 'La primera fila es encabezado',
        lsRowHeaderTxt: 'Cada fila en el archivo debe contener valores para estas columnas: ',
        lsRowHeaderColTxt: 'Nombre, Apellido, Fecha de nacimiento, Sexo',
        lsColumnTxt: 'Columna',
        lsDescriptionTxt: 'DescripciÃ³n',
        lsYesTxt: 'SÃ­',
        lsNoTxt: 'No',
        lsRequiredTxt: 'Necesario',
        lsFirstNameTxt: 'Nombre de pila',
        lsMiddleNameTxt: 'Middle Name',
        lsMiddleNamePlaceholderTxt: 'Middle Name or Middle initial',
        lsLastNameTxt: 'Last Name',
        lsIDTxt: 'Id',
        lsIDDescTxt: 'A unique identifier for this profile',
        lsDOBTxt: 'Date of Birth',
        lsDOBDescTxt: 'Date of Birth using MM/DD/YYYY format',
        lsGenderTxt: 'Gender',
        lsSportTxt: 'Sport',
        lsLevelTxt: 'Level',
        lsEmailTxt: 'Email',
        lsPhoneTxt: 'Phone',
        lsGenderDescTxt: 'Acceptable values are: Male, Female, Other, Unspecified ',
        lsSportDescTxt: '',
        lsLevelDescTxt: '',
        lsEmailDescTxt: '',
        lsPhoneDescTxt: '',
        lsCSVUploadInfoTxt1: 'CSV stands for Comma Separated Values, and it\'s a file format (.csv) for spreadsheets.\
        A CSV file is a text file where each column is separated using a comma (,).',
        lsCSVUploadInfoTxt5: 'Either of email or phone is required.',
        lsCSVUploadInfoTxt2: 'You can download a sample file from {0} here. \
        Although it can be viewed in Excel to better understand how to construct the CSV\
        file format save it and then use a text editor like Notepad to open the csv file.',
        lsCSVUploadInfoTxt3: 'The sample file when opened in at text editor like Notepad or TextEdit will look like:',
        lsCSVUploadInfoTxt4: 'Then sample file when opened in spreadsheet will look like:',
        lsUploadErrorTxt: 'Se encontraron problemas en las siguientes filas enumeradas:',
        lsPhoneErrorTxt: `Please provide below convention for phone number,
country code (area code) subscriber number
E.g, +1-843-298-0595, +1 (843) 298 0595, 1-843-298-0595, (850)9015652, 843-298-0595`,
        lsDOBErrorTxt: `Please provide YYYY/MM/DD or YYYY-MM-DD date format
E.g 2019/02/01, 2019/2/1, 2019-02-01, 2019-2-1`,
        lsEmailErrorTxt: `Please provide valid email address, E.g. john123@mail.com,
"john123" is the email prefix, and "mail.com" is the email domain.`,
        lsClearTxt: 'Clear',
        lsHereTxt: 'here',
        lsDloadSampleTxt: 'Download Sample File',
        lsOtherTxt: 'Other'
    }
});


// WEBPACK FOOTER //
// ./src/eyeguide-localization/profile/strings.profile.bulkupload.tsx